<template>
  <el-dialog v-loading="loading.dialog" class="developing_model_dialog" top="5vh" center
    title="开发部署" width="90%" :before-close="handleClose" :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form ref="form" size="mini" :rules="rules" :model="form">
      <div style="display: flex">
        <el-form-item label="主域名" prop="domain" :label-width="formLabelWidth">
          <el-input  :disabled="true" value="测试测试"></el-input>
        </el-form-item>
        <el-form-item label="系统" label-width="65px">
          <el-input :disabled="true" value="测试"></el-input>
        </el-form-item>
      </div>
      <el-form-item label="测试环境" prop="env" :label-width="formLabelWidth">
        <el-select style="width: 35%" v-model="form.env" filterable @change="queryEnvInfo()" placeholder="请选择测试环境">
          <el-option v-for="(value, key) in ENVS" :key="key" :label="value" :value="key" />
        </el-select>
        <span v-if="nonStandard" style="margin-left: 20px; color: #F56C6C">注：非标任务只支持西域主数据库</span>
        <el-popover v-else @show="queryDeployCenterList()" placement="bottom" width="900" trigger="click">
          <el-table :cell-style="getRowClass" max-height="400" v-loading="loading.envFootprint" :data="deploy_info">
            <el-table-column fixed width="150" property="moduleEnv" label="模块环境"></el-table-column>
            <el-table-column property="name" label="姓名" min-width="120"></el-table-column>
            <el-table-column property="branch" label="分支"></el-table-column>
            <el-table-column property="startDate" label="开始时间" min-width="100" sortable></el-table-column>
            <el-table-column property="holeUpTime" min-width="100" label="占用时间" sortable></el-table-column>
            <el-table-column property="commit" label="commit"></el-table-column>
            <el-table-column fixed="right" width="220" align="center" label="操作">
              <template slot-scope="scope">
                <el-button size="mini" :type="releaseType(scope.row.holeUpTime).type" plain
                  v-if="scope.row.platform === 'walle'" @click="openLink(scope.row.release_url)">发布({{
                    scope.row.platform
                  }})
                </el-button>
                <span v-else
                  :style="`color: ${releaseType(scope.row.holeUpTime).color};width: 91.4px;display: inline-block;text-align: center;margin-right: 10px;`">{{
                    scope.row.platform.toLocaleUpperCase()
                  }}
                </span>
                <el-button size="mini"
                  v-if="scope.row.platform !== 'docker' || releaseType(scope.row.holeUpTime).type === 'success'"
                  type="primary" plain @click="handleRorrelation(scope.$index, scope.row)">查看配置
                </el-button>
                <div style="display:flex" v-else>
                  <el-button size="mini" type="primary" plain @click="handleRorrelation(scope.$index, scope.row)">查看配置
                  </el-button>
                  <el-button size="mini" type="warning" style="margin-top: 4px;" plain
                    @click="handleReleaseOccupy(scope.$index, scope.row)">解除占用
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <span slot="reference" style="margin-left: 20px; color: #67c23a; cursor: pointer">查看环境占用情况</span>
        </el-popover>
        <span style="margin-left: 20px; color: #e6a23c" v-if="intelligentEnv">{{
          intelligentEnv
        }}</span>
      </el-form-item>
      <el-form-item label="额外部署SQL文件" :label-width="formLabelWidth">
        <el-button type="primary" @click="handleSqlDialogVisible('edit')">查看 / 编辑</el-button>
        <el-button type="primary" @click="handleSqlDialogVisible('info')">复制到{{ showGitDeploy ? 'GIT部署路径' : 'SQL' }}
        </el-button>
      </el-form-item>
      <el-form-item v-if="showGitDeploy" label="GIT部署分支" prop="ref" :label-width="formLabelWidth">
        <el-input placeholder="请输入GIT部署分支" v-model="form.ref"></el-input>
      </el-form-item>
      <el-form-item v-if="showGitDeploy" label="GIT部署路径" prop="deploy_filepath" :label-width="formLabelWidth">
        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 16 }"
          placeholder="请输入额外部署Git相对路径，多个以换行分隔，会以扩展名（.py/.sh/.sql/.conf等）区分部署类型" v-model="form.deploy_filepath">
        </el-input>
      </el-form-item>
      <el-form-item :label-width="formLabelWidth">
        <div style="border-top: 1px dashed rgb(220, 223, 230)"></div>
      </el-form-item>
      <el-form-item label="SQL" prop="sqlcontent" :label-width="formLabelWidth">
        <Codemirror v-if="dialog.sqleditor" style="margin-bottom: 10px" ref="sqleditor" :value="form.sqlcontent"
          @changeTextarea="changeTextarea($event, 'sqlcontent')" />
        <div v-else style="height:112px;border: 1px solid #DCDFE6;"></div>
        <el-button type="warning" :loading="loading.testEnvSqlDone" @click="queryTestEnvSqlDone">测试环境执行SQL
        </el-button>
        <el-button type="primary" @click="queryActionNowLogInfo('sql')">实时日志</el-button>
        <el-button type="primary" @click="queryTestEnvSqlDoneLog">查看执行SQL记录</el-button>
        <el-button type="primary" @click="querySqlQualityTest" :loading="loading.sqlQualityTest">SQL质量检测</el-button>
      </el-form-item>
      <el-form-item v-if="nonStandard" label="行为记录" :label-width="formLabelWidth">
        <EditorComment :config="allSelect" :content="form.record" @commentData="changeRecordContent" />
        <div style="margin-top: 10px;">
          <el-button type="warning" :loading="loading.record" @click="submitRecordInfo">记录一下
          </el-button>
          <el-button type="primary" @click="lookRecordList">查看行为记录</el-button>
        </div>
      </el-form-item>
      <div v-else>
        <el-form-item :label-width="formLabelWidth">
          <div style="border-top: 1px dashed rgb(220, 223, 230)"></div>
        </el-form-item>
        <el-form-item label="代码分支" :label-width="formLabelWidth">
          <div style="display: flex">

<!--            <el-select v-if="branchStep === 2" style="width:90%;" size="mini" @change="selectBranch" v-model="form.branch"
              filterable placeholder="请选择代码分支">
              <el-option v-for="(key, value) in BRANCHS" :key="key" :label="key" :value="value">
              </el-option>
            </el-select>
            <div v-else style="text-decoration: underline;color: #409EFF;cursor: pointer;line-height: 29px;"
              @click="openLink(form.branch_web_url_prefix + cacheBranch)">
              {{ form.branch }}
            </div>-->
<!--            <div v-if="is_admin" style="display: flex;">
              <el-button style="margin-left: 10px;" type="primary" v-show="branchStep === 1"
                @click="branchStep = 2">编辑</el-button>
              <el-button style="margin-left: 10px;" :loading="loading.branch" v-show="branchStep === 2" type="primary"
                @click="queryUpdateDevbranch">确定</el-button>
              <el-button style="margin-left: 10px;" type="primary" v-show="branchStep === 2"
                @click="cancelDevbranch">取消</el-button>
            </div>-->
          </div>
        </el-form-item>
        <el-form-item label="版本" prop="commit" :label-width="formLabelWidth">
          <div style="display: flex">
            <el-select style="width: 90%;" v-model="form.commit" filterable placeholder="默认为当前分支的最新版本">
              <el-option v-for="item in TEXTCOMMITS" :key="item[0]" :label="item[1]" :value="item[0]" />
            </el-select>
            <el-button :loading="loading.commit" type="primary" style="margin-left: 10px;"
              @click="queryDevOpsSpaceStageSelectmapApi(form.module, 'commit')">刷新</el-button>
          </div>
        </el-form-item>
        <el-form-item label="占用期限" prop="due_time" :label-width="formLabelWidth">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" v-model="form.due_time" type="datetime"
            default-time="23:59:59" placeholder="默认占用至当天结束" />
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-button :loading="loading.testEnvRelease" type="warning" @click="checkEnvReleaseOccupation">测试环境发布
          </el-button>
          <el-button type="primary" @click="queryActionNowLogInfo('env')">实时日志</el-button>
          <el-button type="primary" @click="queryTestEnvReleaseLog()">查看发布记录</el-button>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
<!--      <el-button type="warning" :loading="loading.toTest" @click="submit">提 测</el-button>-->
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
    <!--  #region dialogVisible 部分 -->
    <el-dialog :close-on-click-modal="false" custom-class="developing_model_dialog_child" width="80%" center
      :title="showId + '额外部署SQL文件'" :visible.sync="dialog.sqlVisible" append-to-body>
      <Codemirror v-if="dialog.sqlVisible" style="margin-bottom: 10px" sqlStyle="height:200px;" ref="sqlFileditor"
        :value="form.sqlExtracontent" @changeTextarea="changeTextarea($event, 'sqlExtracontent')" />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSqlDialogVisible('save')">保存</el-button>
        <span style="font-size: 15px;color: #666;font-weight: bold;margin-left: 10px;position: absolute;bottom: 30px;"
          v-if="sqlQualityTestInfo.score < 100">
          分数:<span :style="{ color: sqlQualityTestInfo.score > 90 ? '#67C23A' : '#E6A23C' }">{{ sqlQualityTestInfo.score
          }}</span><a style="color: rgb(64, 158, 255);margin-left: 20px;" :href="sqlQualityTestInfo.origin_url"
            target="_blank" v-if="sqlQualityTestInfo.origin_url">查看报告</a>
        </span>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="developing_model_dialog_child" width="80%" center
      :title="showId + '测试环境执行SQL'" v-if="dialog.sqlDoneVisible" :visible.sync="dialog.sqlDoneVisible" append-to-body>
      <Progress :progressInfo="progressBar" />
      <pre ref="webSocket" v-html="webSocket.msg" class="tips-message websocket_style" />
      <WebSocket v-if="webSocket.url" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="developing_model_dialog_child" width="80%" center
      :title="showId + 'SQL执行历史记录'" :visible.sync="dialog.sqlLogVisible" append-to-body>
      <TableFive :moduleType="form.module" :tableData="tableData.sqlList" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="developing_model_dialog_child" width="80%" center
      :title="showId + '测试环境代码发布'" v-if="dialog.releaseResultVisible" :visible.sync="dialog.releaseResultVisible"
      append-to-body>
      <Progress :progressInfo="progressBar" />
      <pre ref="webSocket" class="tips-message websocket_style" v-html="webSocket.msg" />
      <WebSocket v-if="webSocket.url" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="developing_model_dialog_child" width="80%" center
      :title="showId + '发布记录'" :visible.sync="dialog.releaseLogVisible" append-to-body>
      <el-tabs v-if="tableData.releaseList.length" type="border-card">
        <el-tab-pane v-for="(item, index) in tableData.releaseList" :value="0" :name="String(index)" :key="index"
          :label="item.label">
          <TableOne v-if="item.list.length" :tableData="item.list" />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="developing_model_dialog_child" center :title="showId + '关联配置'"
      :visible.sync="dialog.rorrelationVisible" width="80%" append-to-body left>
      <pre tyle="white-space: pre-line;height: 300px;overflow-y: auto;background-color: #efefef;">
                              {{ msg.rorrelationContentMsg }}
                          </pre>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="developing_model_dialog_child" center :title="showId + '提测日志'"
      :visible.sync="dialog.toTestVisible" width="80%" append-to-body left>
      <TableThir v-if="codeReview.total" :codeSuccessTotal="codeReview.successNum" :tableData="codeReview.tableData"
        title="检查项：CodeReview检测" :msg="codeReview.msg" />
      <div style="margin-top:15px" v-if="showNext !== 2">提测{{ showNext ? '成功' : '失败' }}</div>
      <pre v-if="msg.toTestMsg" v-html="msg.toTestMsg" class="tips-message"></pre>
      <div slot="footer" v-if="showNext === 1" class="dialog-footer">
<!--        <el-button type="primary" @click="handleClose('toTest')">下一步</el-button>-->
        <el-button type="primary" @click="handleClose()">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialog.releaseTipVisible" width="60%" center append-to-body>
      <div style="text-align:center;">该环境（{{
        ENVS[current_deploy_info.env]
      }}）已被占用至（{{ current_deploy_info.time }}），请与{{ allSelect.TEXTUSERS[current_deploy_info.name] }}（{{
  current_deploy_info.name
}}）联系，确认后再点击继续发布
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialog.releaseTipVisible = false">取 消</el-button>
        <el-button type="warning" @click="queryTestEnvRelease">继续发布</el-button>
      </span>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="preEnvTesting_model_dialog_child" width="80%" center
      :title="showId + '实时日志'" v-if="dialog.releaseResultLogVisible" :visible.sync="dialog.releaseResultLogVisible"
      append-to-body>
      <pre ref="webSocket" class="tips-message websocket_style" v-html="webSocket.msg" />
      <WebSocket v-if="webSocket.url" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="developing_model_dialog_child" width="40%" center
      :title="showId + 'SQL质量检测'" :visible.sync="dialog.sqlQualityTest" append-to-body>
      <div
        style="display: flex;padding: 10px 20px;font-size: 15px;color: #666;justify-content: space-around;font-weight: bold">
        <div :style="{ color: sqlQualityTestInfo.score > 90 ? '#67C23A' : '#E6A23C' }"><span
            style="color: #666;">分数：</span>{{ sqlQualityTestInfo.score }}</div>
        <a style="color: rgb(64, 158, 255);" :href="sqlQualityTestInfo.origin_url" target="_blank"
          v-if="sqlQualityTestInfo.origin_url">查看报告</a>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="developing_model_dialog_child" width="80%" center
      :title="showId + '行为记录'" :visible.sync="dialog.recordListVisible" append-to-body>
      <TableRecord v-if="recordList.length" :tableData="recordList" />
    </el-dialog>
    <!--  #endregion -->
  </el-dialog>
</template>
<script>
import {
  postODUDADcreateApi,
  getDevOpsSpaceListStageParmApi,
  postDevopsSpaceStageActionApi,
  getEdiApi,
  postUpdateEdiApi,
  postDeployCenterApi,
  getAutoCustomerApi,
  getDevOpsSpaceListStageOutputApi,
  postTechReviewerApi,
  postDeployRecordingApi,
  postUpdateDevbranchApi
} from "@/server/tops/devOps";
import {
  TableFive,
  TableOne,
  TableThir,
  TableRecord
} from "@/views/tops/devOps/components/table/index.js";
import { Codemirror, Progress, WebSocket, EditorComment } from "@/components";
import {
  formatDate,
} from "@/views/tops/devOps/components/util.js";
import { mapState, mapMutations } from "vuex";
export default {
  components: { Codemirror, TableFive, Progress, TableOne, TableThir, TableRecord, WebSocket, EditorComment },
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { };
      },
    },
  },
  data() {
    return {
      form: {
        domain: "",
        env: "intelligent",
        commit: "",
        sqlExtracontent: "",
        sqlcontent: "",
      },
      rules: {
        env: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: "135px",
      ENVS: {},
      dialog: {
        sqlVisible: false,
        releaseResultVisible: false,
        sqlDoneVisible: false,
        sqlLogVisible: false,
        rorrelationVisible: false,
        releaseLogVisible: false,
        toTestVisible: false,
        releaseTipVisible: false,
        releaseResultLogVisible: false,
        sqleditor: true,
        sqlQualityTest: false,
        recordListVisible: false
      },
      loading: {
        testEnvSqlDone: false,
        testEnvRelease: false,
        toTest: false,
        envFootprint: false,
        commit: false,
        dialog: false,
        updateTechReviewer: false,
        branch: false,
        sqlQualityTest: false,
        record: false
      },
      tableData: {
        sqlList: [],
        releaseList: [],
        toTestList: [],
      },
      msg: {
        rorrelationContentMsg: "",
        toTestMsg: "",
        codeQualityInspectUrlMsg: "",
      },
      // #region 环境部分
      deploy_info: [],
      current_deploy_info: {},
      intelligentEnv: "",
      // #endregion
      BRANCHS: {},
      // 版本列表
      TEXTCOMMITS: {},
      // 开发代码审查
      codeReview: {
        successNum: 0,
        failNum: 0,
        total: 0,
        tableData: [],
      },
      // 是否展示下一步
      showNext: 2, // 0 失败 1 成功 2不展示
      showId: '',
      is_admin: 0, // 0 不是管理员 1 是管理员
      branchStep: 1,
      sqlQualityTestInfo: {}, // sql质量检测信息
      recordList: [], // 行为记录列表
    };
  },
  async created() {
    const {
      taskId,
      reviewerId,
      module = "",
      pmId = "",
      id = "",
      branch = "",
      domain = ""
    } = this.formInfo;
    this.form = { ...this.form, id: taskId, pid: id, module, branch , domain };
    this.showId = `【${id}.${taskId}】`
   //await this.queryDevOpsSpaceListStageParmInfo();
    this.queryDevOpsSpaceStageSelectmapApi(module);
  },
  computed: {
    ...mapState({
      progressBar: (state) => state.devOps.PROGRESSSBAR,
      allSelect: (state) => state.devOps.ALLSELECT,
      webSocket: (state) => state.devOps.WEBSOCKET
    }),
    showGitDeploy() {
      const { module = '', domain = '' } = this.form;
      const newOrigin = `${module}.${domain}`;
      const origins = ['odoo.ehsy.com', 'mall.raxwell.cn']
      return origins.includes(newOrigin);
    },
    nonStandard() { // 非标系统标识
      return this.form.module.startsWith('非标-')
    }
  },
  updated() {
    this.scrollToBottom({ bind: this, refName: 'webSocket' })
  },
  methods: {
    ...mapMutations(['setProgressBar', 'openWebSocket', 'sendWebSocket', 'closeWebSocket', 'scrollToBottom']),
    // 环境占用情况样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      // console.log(row, column, rowIndex, columnIndex)
      if (columnIndex === 4) {
        return `color:${this.releaseType(row.holeUpTime).color};`
      }
    },
    selectBranch() {
      this.queryDevOpsSpaceStageSelectmapApi(this.form.module, 'commit')
    },
    // 获取select
    async queryDevOpsSpaceStageSelectmapApi(module, type) {
      try {
        this.loading.commit = true;
        const ret = await postODUDADcreateApi({
          module_name: module || "BACKEND",
          branch: this.form.branch || "",
          stage_env: 'dev',
          domain: this.form.domain
        });
        if (type === 'commit') {
          this["TEXTCOMMITS"] = ret?.commits?.map((v) => {
            return [v.split(" ")[0], v];
          });
          this.form.commit = ret.commits[0]?.split(" ")[0] || "";
          return;
        };
        let envs = {};
        ret.envs.map((item) => {
          return (envs[item[1]] = item[0]);
        });
        this["ENVS"] = envs;
        this.queryEnvInfo();

        let branchs = {}
        ret.branchs.map((item) => { branchs[item] = item; });
        this['BRANCHS'] = branchs;
        this["TEXTCOMMITS"] = ret?.commits?.map((v) => {
          return [v.split(" ")[0], v];
        });
        this.form.commit = ret.commits[0]?.split(" ")[0] || "";
      } catch (error) {
        this.$notify({
          message: error || "获取select失败",
          type: "error",
        });
      } finally {
        this.loading.commit = false;
        this.loading.dialog = false;
      }
    },
    // 获取开发中任务阶段设置信息
    async queryDevOpsSpaceListStageParmInfo() {
      try {
        const { id = "", pid = "" } = this.form;
        const ret = await getDevOpsSpaceListStageParmApi({
          stage_id: "6",
          task_id: id,
          pid,
        });
        if (ret.status === "success") {
          const { common_branch: branch = '', env = '', branch_web_url_prefix = '', due_time = '', is_admin = 0 } = ret.data || {};
          this.form = {
            ...this.form,
            branch,
            branch_web_url_prefix,
            env,
            sqlcontent: "",
            due_time,
          };
          this.is_admin = is_admin;
          this.cacheBranch = branch;
        } else {
          this.$notify({
            message: ret.error || "数据错误",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        });
      } finally {
        this.loading.dialog = false;
      }
    },
    // 更新分支
    async queryUpdateDevbranch() {
      try {
        this.loading.branch = true;
        const { id: tid = '', branch = '' } = this.form;
        const params = { tid, branch };
        const ret = await postUpdateDevbranchApi(params);
        if (ret.data.code === 0) {
          this.branchStep = 1;
          this.cacheBranch = this.form.branch;
        }
        this.$notify({
          message: ret.data.msg || "数据错误",
          type: ret.data.code === 0 ? "success" : "error",
        });
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        });
      } finally {
        this.loading.branch = false;
      }
    },
    // 取消分支修改
    cancelDevbranch() {
      this.branchStep = 1;
      this.form.branch = this.cacheBranch;
      this.queryDevOpsSpaceStageSelectmapApi(this.form.module);
    },
    // 修改富文本内容
    changeRecordContent({ text, cid, show }) {
      this.form.record = text
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step);
    },
    //设置sql语句
    changeTextarea(val, type) {
      this.$set(this.form, type, val);
    },
    // 设置技术评审员
    async setTechReviewer() {
      try {
        this.loading.updateTechReviewer = true;
        const {
          user_rd,
          id: tid = "",
          pid = "",
          tech_reviewer = []
        } = this.form || {};
        if (!tech_reviewer.length) {
          this.$notify({
            message: '请选择技术评审人',
            type: "warning",
          })
          return;
        }
        const param = {
          pid, tid, tech_reviewer: tech_reviewer.toString(), "stage_id": 5, user_rd
        }
        const ret = await postTechReviewerApi(param);
        this.$notify({
          message: ret.data?.msg || '数据错误',
          type: ret.data?.code === 0 ? "success" : "error",
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading.updateTechReviewer = false;
      }
    },
    // 编辑额外部署sql文件
    async handleSqlDialogVisible(type) {
      const { id, pid } = this.form;
      let ret = {};
      try {
        switch (type) {
          case "info":
            this.dialog.sqleditor = false;
            ret = await getEdiApi({ id, pid });
            this.showGitDeploy ? this.form.deploy_filepath = ret.data : this.form.sqlcontent = ret.data;
            break;
          case "edit":
            ret = await getEdiApi({ id, pid });
            this.form.sqlExtracontent = ret.data || "";
            this.sqlQualityTestInfo = {};
            break;
          case "save":
            ret = await postUpdateEdiApi({
              id,
              content: this.form.sqlExtracontent,
              pid,
            });
            break;
          default:
            break;
        }
        if (ret.status === "success") {
          if (type === 'info') return;
          this.dialog.sqlVisible = type === "edit" ? true : false;
        } else {
          if (type === 'save') {
            this.sqlQualityTestInfo = ret.data.data;
            this.dialog.sqlVisible = true;
            this.$notify({
              message: "保存失败",
              type: "error",
            });
            return;
          };
          this.$notify({
            message: "数据错误",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        });
      } finally {
        this.dialog.sqleditor = true;
      }
    },
    // 获取智能选择环境
    async queryEnvInfo() {
      const { env = "", id: task_id = "", pid = "" } = this.form;
      if (env !== "intelligent") return (this.intelligentEnv = "");
      if (Object.keys(this['ENVS']).length < 2) return (this.intelligentEnv = "此系统暂时无环境，请直接跳过")
      const param = {
        action: "runget",
        stage_id: "6",
        task_id,
        stage_name: "tester_testCodeDeploy",
        env,
        pid,
      };
      try {
        this.intelligentEnv = "";
        const ret = await postDevopsSpaceStageActionApi(param);
        if (this.form.env && this.form.env !== 'intelligent') return;
        if (JSON.stringify(ret) === '{}') {
          this.intelligentEnv = "首次发布，请自行选择环境";
          this.form.env = ''
        } else {
          this.intelligentEnv = `智能选择的环境为 ${ret || ''}`
          this.form.env = ret || "";
        }
      } catch (error) {
        this.intelligentEnv = "";
        this.form.env = "";
      }
    },
    // 获取环境占用列表
    async queryDeployCenterList() {
      try {
        this.loading.envFootprint = true;
        const { module = "", pid = "", domain = '' } = this.form;
        const ret = await postDeployCenterApi({
          action: "add",
          services: module ? [module] : [],
          pid,
          env: 'test',
          domain
        });
        let deploy_info = [];
        ret[module]?.deploy_info?.forEach((item) => {
          item?.records.forEach((itm) => {
            deploy_info.push({
              moduleEnv: itm[2],
              name: itm[0],
              branch: itm[4],
              rorrelation_url:
                item.config_url_prefix + itm[2] + item.config_url_postfix,
              release_url: itm[1],
              holeUpTime: itm[6],
              commit: itm[3],
              startDate: itm[5],
              platform: item.platform,
              record_id: itm[8] || ''
            });
          });
        });
        deploy_info.sort(function (a, b) {
          return new Date(a.holeUpTime) - new Date(b.holeUpTime);
        });
        this.deploy_info = deploy_info;
      } catch (error) {
      } finally {
        this.loading.envFootprint = false;
      }
    },
    // 解除环境占用
    async handleReleaseOccupy(index, row) {
      try {
        const param = {
          action: "deploy_update_duetime",
          record_id: row.record_id
        }
        const ret = await postDeployRecordingApi(param)
        this.$notify({
          message: ret.msg,
          type: ret.status === 'success' ? "success" : "error",
        })
        this.queryDeployCenterList()
      } catch (error) {
        this.$notify({
          message: "数据错误",
          type: "error",
        })
      }
    },
    // 发布类型判断
    releaseType(time) {
      if (!time) return { type: "success", color: '#67C23A' };
      let t = this.$moment().diff(time, "hour");
      if (t <= -24) {
        return { type: "danger", color: '#F56C6C' };
      } else if (t >= 0) {
        return { type: "success", color: '#67C23A' };
      } else {
        return { type: "warning", color: '#E6A23C' };
      }
    },
    // 打开外链接
    openLink(url) {
      window.open(url);
    },
    // 关联配置
    async handleRorrelation(index, row) {
      try {
        const ret = await getAutoCustomerApi(row.rorrelation_url);
        this.msg.rorrelationContentMsg = ret || "";
        if (ret) {
          this.dialog.rorrelationVisible = true;
        }
      } catch (error) {
        this.msg.rorrelationContentMsg = "";
        this.dialog.rorrelationVisible = false;
      }
    },
    // 测试环境sql 执行成功失败判断
    isSqlSuccess(output = {}) {
      if (typeof output === 'string') return false
      let flag = true;
      ["sql", "script", "conf"].forEach((i) => {
        if (output[i].length && output[i][0].code !== 0) {
          flag = false;
        }
      });
      return flag && output?.msg?.code === 0;
    },
    // 测试环境sql执行
    async queryTestEnvSqlDone() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loading.testEnvSqlDone = true;
          this.dialog.sqlDoneVisible = true;
          const cacheDate = new Date();
          const {
            module = "",
            ref = "",
            deploy_filepath = "",
            env = "",
            id = "",
            pid = "",
            sqlcontent = "",
            user_rd = ''
          } = this.form;

          let param = {
            action: "run",
            stage_id: 5,
            task_id: id,
            stage_name: "tester_testExtraDeploy",
            module_type: module,
            env,
            sqlcontent,
            pid,
            user_rd,
          };
          if (module === "odoo") {
            param.ref = ref;
            param.deploy_filepath = deploy_filepath;
          }
          const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
          this.openWebSocket({ url: '/ws/devops', params: { pid, task_id: id, stage_id: 5, username }, title: '测试环境sql部署中' })
          try {
            const ret = await postDevopsSpaceStageActionApi(param);
            const output = ret?.data?.output || {};
            const isSuccess = this.isSqlSuccess(output);
            this.timeOutSetProgressBar(`SQL执行${isSuccess ? "成功" : "失败"}，用时：${formatDate(this, this.$moment(new Date()).diff(cacheDate))}`, `${isSuccess ? "success" : "exception"}`)
            if (typeof output === 'string') {
              this.$notify({
                message: output || "数据错误",
                type: "error",
              });
            }
          } catch (error) {
            this.dialog.sqlDoneVisible = false;
            this.$notify({
              message: error || "数据错误",
              type: "error",
            });
          } finally {
            this.loading.testEnvSqlDone = false;
          }
        }
      })
    },
    // 获取sql执行记录
    async queryTestEnvSqlDoneLog() {
      try {
        const { id, pid } = this.form;
        const ret = await getDevOpsSpaceListStageOutputApi({
          stage_id: "5",
          task_id: id,
          pid,
        });
        if (ret.status === "success") {
          let instance = JSON.parse(ret.data) || [];
          instance.map((item) => {
            return (item.content = JSON.stringify(item.output, null, 2));
          });
          this.tableData.sqlList = instance.map((item) => {
            return {
              state: this.isSqlSuccess(item?.output) ? 0 : 1,
              content: item.content,
              logtime: item.logtime,
              deploy_filepath: item?.output?.msg?.parms?.deploy_filepath || "",
              sqlcontent: item?.output?.msg?.parms?.sqlcontent || "",
              module_type: item?.output?.msg?.parms?.module_type || "",
            };
          });
          this.dialog.sqlLogVisible = true;
        }
      } catch (error) {
        this.tableData.sqlList = [];
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // Sql质量检测
    async querySqlQualityTest() {
      try {
        this.loading.sqlQualityTest = true;
        const param = {
          action: "sql_assess",
          task_id: this.form.id,
          content: this.form.sqlcontent
        }
        const ret = await postDevopsSpaceStageActionApi(param);
        if (ret.status === 'success') {
          this.sqlQualityTestInfo = ret.data;
          this.dialog.sqlQualityTest = true;
        }
      } catch (error) {

      } finally {
        this.loading.sqlQualityTest = false;
      }
    },
    // 查看发布环境占用情况
    async checkEnvReleaseOccupation() {
      await this.queryDeployCenterList()
      let flag = false;
      this.deploy_info.some(itm => {
        const name = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
        const { module = '', env = '', domain = '' } = this.form;
        if ((itm.moduleEnv === `${module}-${env}.${domain}`) && itm.name !== name) {
          if (!itm.holeUpTime) return;
          const compareTime = Date.parse(itm.holeUpTime) > Date.now()
          if (compareTime) {// true提醒 false不提醒
            this.current_deploy_info = {
              env: env,
              time: itm.holeUpTime,
              name: itm.name
            }
            flag = true;
          }
        }
      })

      if (flag) {
        this.dialog.releaseTipVisible = true;
      } else {
        this.queryTestEnvRelease()
      }
    },
    // 实时日志
    async queryActionNowLogInfo(type) {
      const {
        id: task_id = "",
        pid = ''
      } = this.form;
      const stage_id = type === 'sql' ? 5 : 6;
      this.dialog.releaseResultLogVisible = true;
      const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
      this.openWebSocket({
        url: '/ws/devops',
        params: { pid, task_id, stage_id, username },
        title: '实时日志'
      })
    },
    // 测试环境发布
    async queryTestEnvRelease() {
      if (this.branchStep === 2) {
        this.$notify({
          message: "请确认/取消代码分支",
          type: "warning",
        });
        return;
      }
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.dialog.releaseTipVisible = false;
          this.loading.testEnvRelease = true;
          this.dialog.releaseResultVisible = true;
          const cacheDate = new Date();
          const {
            module = "",
            due_time = "",
            branch = "",
            commit = "",
            env = "",
            domain = "",
            id = "",
            pid = "",
            user_rd = ''
          } = this.form;
          const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
          this.openWebSocket({ url: '/ws/devops', params: { pid, task_id: id, stage_id: 2, username }, title: '代码质量检测中', apiCount: 2 })
          try {
            const param1 = {
              action: "run",
              stage_id: 2,
              task_id: id,
              stage_name: "developer_codeQualityInspect",
              branch,
              pid,
              user_rd,
            };
            const ret1 = await postDevopsSpaceStageActionApi(param1);
            // 代码质量检测日志
            if (ret1?.data?.output?.report?.length) {
              let { report = [], runmsg = [] } = ret1.data.output;
              let runmagNum = 0;
              runmsg.forEach((itm) => {
                itm.code === 0 && runmagNum++;
              });
              let runmsgRes = (runmsg.length ? runmagNum === runmsg.length : false);
              const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
              if (report[0]?.code === 0 && runmsgRes) {
                this.sendWebSocket({ params: { pid, task_id: id, stage_id: 6, username }, title: "代码质量检测完成，开始代码发布", })
                const param2 = {
                  pid,
                  action: "run",
                  stage_id: 6,
                  task_id: id,
                  stage_name: "tester_testCodeDeploy",
                  domain,
                  module,
                  due_time,
                  branch,
                  commit,
                  env,
                  user_rd,
                };
                const ret2 = await postDevopsSpaceStageActionApi(param2);
                const output = ret2?.data?.output || {};
                if (typeof output === 'string') {
                  this.$notify({
                    message: output || "数据错误",
                    type: "error",
                  });
                }
                const isSuccess = typeof output === 'string' ? true : ret2.data?.output?.deploy[0]?.code === 0;
                this.timeOutSetProgressBar(`发布${isSuccess ? "成功" : "失败"}，用时：${formatDate(this, this.$moment(new Date()).diff(cacheDate))}`, `${isSuccess ? "success" : "exception"}`)
              } else {
                this.timeOutSetProgressBar('代码质量检测失败')
              }
            } else {
              this.timeOutSetProgressBar('代码质量检测失败')
            }
          } catch (error) {
            this.timeOutSetProgressBar('发布失败')
          } finally {
            this.loading.testEnvRelease = false;
          }
        }
      })
    },
    // 延迟设置进度条
    timeOutSetProgressBar(completeInfo, status = 'exception') {
      const initProgressBar = {
        percentage: 100,
        title: this.form.module || '',
        customColor: "",
      }
      setTimeout(() => {
        this.setProgressBar({
          ...initProgressBar,
          completeInfo,
          status,
        });
      }, 500)
    },
    // 获取测试环境历史执行信息
    async queryTestEnvReleaseLog() {
      const { pid = "", id = "" } = this.form;
      try {
        Promise.all([getDevOpsSpaceListStageOutputApi({
          stage_id: 2,
          task_id: id,
          pid
        }), getDevOpsSpaceListStageOutputApi({
          stage_id: 6,
          task_id: id,
          pid
        })]).then((list) => {
          this.tableData.releaseList = []
          list.forEach((itm, idx) => {
            let obj = {
              label: idx === 0 ? '代码质量检测' : '测试环境发布',
              list: JSON.parse(itm.data) || []
            }
            obj.list.map((im, ix) => {
              im.content = JSON.stringify(im.output, null, 2)
              return im;
            });
            this.tableData.releaseList.push(obj);
          })
          this.dialog.releaseLogVisible = true;
        })
      } catch (error) {
        this.tableData.releaseList = [];
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 提交非标记录
    async submitRecordInfo() {
      try {
        const { pid, id: task_id, domain, module, user_rd, record, user_qa } = this.form;
        if (!record) return;
        this.loading.record = true;
        const ret = await postDevopsSpaceStageActionApi({ stage_name: 'tester_testCodeDeploy', action: 'runactionrecord', pid, stage_id: 6, task_id, domain, module, user_rd, record, user_qa })
        const actionRecord = ret.data?.output?.actionRecord || [];
        if (actionRecord[0]?.code === 0) {
          this.$notify({
            message: actionRecord
            [0]?.msg,
            type: "success",
          })
        }
      } catch (error) {
        this.$notify({
          message: error || '记录保存失败',
          type: "error",
        })
      } finally {
        this.loading.record = false;
      }
    },
    // 查询历史非标记录
    async lookRecordList() {
      try {
        const {
          id: task_id,
          pid
        } = this.form;
        const ret = await getDevOpsSpaceListStageOutputApi({
          pid,
          stage_id: 6,
          task_id,
        });
        if (ret.status === 'success') {
          this.recordList = JSON.parse(ret.data || '[]');
          this.dialog.recordListVisible = this.recordList.length > 0;
        } else {
          this.recordList = []
        }
      } catch (error) {
        this.recordList = []
        this.$notify({
          message: error || '记录查询失败',
          type: "error",
        })
      }
    },
    // 提测1
    async submit() {
      if (this.branchStep === 2) {
        this.$notify({
          message: "请确认/取消代码分支",
          type: "warning",
        });
        return;
      }
      this.codeReview = { successNum: 0, failNum: 0, total: 0, tableData: [] };
      this.loading.toTest = true;
      this.msg.toTestMsg = "";
      this.showNext = 2;
      this.dialog.toTestVisible = true;
      if (this.nonStandard) {
        this.submitTest()
        return;
      }
      const {
        branch = "",
        id = "",
        pid = "",
        sqlcontent = "",
        user_rd = '',
        tech_reviewer = []
      } = this.form;
      let param1 = {
        action: "run",
        stage_id: "3",
        task_id: id,
        stage_name: "developer_codeReview",
        sqlcontent,
        pid,
        branch,
        user_rd,
        tech_reviewer: tech_reviewer.toString(),
      };
      try {
        const ret1 = await postDevopsSpaceStageActionApi(param1);
        if (ret1.status === "success" && ret1.data?.output?.commits) {
          let codeReview = {
            successNum: 0,
            failNum: 0,
            total: 0,
            msg: '',
            tableData: [],
          };
          codeReview.tableData = ret1.data.output.commits.map((item) => {
            item.code === 0 ? codeReview.successNum++ : codeReview.failNum++;
            codeReview.total++;
            const {
              updated_at = "",
              author = { author },
              body = "",
            } = item.discussions[0] || {};
            let new_updated_at = updated_at
              ? this.$moment(updated_at).format("YYYY-MM-DD HH:mm:ss")
              : "";
            let obj = {
              short_id: item.short_id || "",
              updated_at: new_updated_at,
              name: author.name || "",
              body,
              title: item.title || "",
            };
            return obj;
          });
          this.codeReview = codeReview;
          if (codeReview.total === codeReview.successNum) {
            this.submitTest()
          } else {
            codeReview.msg = ret1.data?.output?.msg
          }
        } else {
          this.msg.toTestMsg = ret1.data || "数据错误";
        }
      } catch (error) {
        this.msg.toTestMsg = error || "数据错误";
      } finally {
        this.loading.toTest = false;
      }
    },
    // 提测2
    async submitTest() {
      try {
        const {
          id = "",
          pid = "",
          user_qa = "",
          user_rd = '',
          tech_reviewer = []
        } = this.form;
        const param2 = {
          action: "run",
          stage_id: 4,
          task_id: id,
          stage_name: "developer_applyTest",
          user_qa: user_qa.toString(),
          pid,
          user_rd,
          tech_reviewer: tech_reviewer.toString()
        };
        const ret2 = await postDevopsSpaceStageActionApi(param2);
        this.msg.toTestMsg = JSON.stringify(ret2.data || "", null, 2);
        const output = ret2.data?.output || {};
        if (typeof output === 'string') {
          this.showNext = 0;
          return;
        }
        if (output?.applytest && output?.applytest[0] && output?.applytest[0]?.code === 0) {
          this.showNext = 1;
        } else {
          this.showNext = 0;
        }
      } catch (error) {
        this.msg.toTestMsg = error || "数据错误";
      } finally {
        this.loading.toTest = false;
      }
    }
  },
};
</script>
<style lang="scss">
.developing_model_dialog {
  .el-dialog__body {
    padding-bottom: 0;
  }
}

.developing_model_dialog_child {
  .el-dialog__body {
    padding: 0 20px 10px;
  }
}
</style>